<div class="job-wrap">
  <p class="pagetitle">
    <span class="pointer-links" (click)="nav('/')">Home /</span
    ><span class="pointer-links"  (click)="nav('/careers/kalpita-open-positions')"
      >Open Positions</span
    >
    / {{ jobDetails && jobDetails?.JobTitle }}
  </p>
  
  <div class="container mt-5" *ngIf="jobDetails && jobDetails">
    <div class="row mt-5">
      <h1 class="apply-paading">{{ jobDetails?.JobTitle }}</h1>
      <div class="col-lg-6 col-xl-3 job-column">
        <p class="job-details m-0">Posted on: {{ jobDetails?.JobPostedDate }}</p>
      </div>
      <div class="col-lg-6 col-xl-3 job-column">
        <p class="job-details m-0">Experience: {{ jobDetails?.Experience }}</p>
      </div>
      <div class="col-lg-6 col-xl-3 job-column">
        <p class="job-details m-0"><i class="ri-map-pin-2-fill"></i> {{ jobDetails?.Location }}</p>
      </div>
      <div class="col-lg-6 col-xl-3 job-column">
        <p class="job-idfloat job-details m-0">Job ID {{ jobDetails?.JobId }}</p>
      </div>
    </div>
  </div>
  
  <div class="container-fluid backimg">
    <div class="row pt-3 text-white">
      <div class="role col-md-12">
        <h3 class="py-2">Role Requirements</h3>
  
        <ul class="pe-5" *ngIf="jobDetails && jobDetails">
          <li *ngFor="let item of jobDetails?.updatedTechnicalExperties">
            {{ item }}
          </li>
        </ul>
      </div>
    </div>
  
    <div class="container pull-upcontainer">
      <form [formGroup]="applyForm"  class="applyform" autocomplete="off">
        <div class="row">
          <h3>Application</h3>
          <div class="col-md-6 py-2">
            <p>
              <input
                class="inpfield"
                type="text"
                formControlName="FirstName"
                required
                placeholder="First Name"
              />
              <span
                class="valimassage"
                style="color: red"
                *ngIf="
                  (FirstName && FirstName.invalid && FirstName.touched) ||
                  (bool1 && FirstName && FirstName.invalid)
                "
                >First Name Required</span
              >
            </p>
          </div>
          <div class="col-md-6 py-2">
            <p>
              <input
                class="inpfield"
                type="text"
                formControlName="LastName"
                required
                placeholder="Last Name"
              />
              <span
                style="color: red"
                *ngIf="
                  (LastName && LastName.invalid && LastName.touched) ||
                  (bool1 && LastName && LastName.invalid)
                "
                >Last Name Required</span
              >
            </p>
          </div>
          <div class="col-md-6 py-2">
            <p>
              <input
                class="inpfield"
                type="text"
                formControlName="email"
                required
                placeholder="Email Address"
                pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
              />
              <span
                class="valimassage"
                style="color: red"
                *ngIf="
                  (email && email.invalid && email.touched) ||
                  (bool1 && email && email.invalid)
                "
                >Email Required</span
              >
            </p>
          </div>
          <div class="col-md-6 py-2">
            <p>
              <input
                class="inpfield"
                maxlength="10"
                type="text"
                formControlName="contact"
                required
                placeholder="Contact number"
                numbersOnly
              />
              <span
                style="color: red"
                *ngIf="
                  (contact && contact.invalid && contact.touched) ||
                  (bool1 && contact && contact.invalid)
                "
              >
                Contact Required</span
              >
            </p>
          </div>
  
          <div class="col-md-12">
            <p>
              <label class="experience">Total Experience</label>
              <input
                type="text"
                maxlength="2"
                formControlName="experience"
                required
                placeholder="In Years"
                numbersOnly
              />
              <span
                class="pe-5"
                style="color: red"
                *ngIf="
                  (experience && experience.invalid && experience.touched) ||
                  (bool1 && experience && experience.invalid)
                "
              >
                Required</span
              >
            </p>
          </div>
          <!-- Current CTC and Expected CTC sections here................................. -->
          <!-- <div class="col-md-6">
            <p>
              <label class="experience">Current CTC</label>
              <input
                type="text"
                maxlength="2"
                formControlName="experience"
                required
                placeholder="In INR"
                numbersOnly
              />
              <span
                class="pe-5"
                style="color: red"
                *ngIf="
                  (experience && experience.invalid && experience.touched) ||
                  (bool1 && experience && experience.invalid)
                "
              >
                Required</span
              >
            </p>
          </div>
  
          <div class="col-md-6">
            <p>
              <label class="experience">Expected CTC</label>
              <input
                type="text"
                maxlength="2"
                formControlName="experience"
                required
                placeholder="In INR"
                numbersOnly
              />
              <span
                class="pe-5"
                style="color: red"
                *ngIf="
                  (experience && experience.invalid && experience.touched) ||
                  (bool1 && experience && experience.invalid)
                "
              >
                Required</span
              >
            </p>
          </div> -->
          <!-- Current CTC and Expected CTC sections here................................. -->
          <div class="col-md-12">
            <p>
              <label class="experience"
                >Were you Previously Employed by Kalpita?</label
              >
              <select formControlName="EmployeeStatus" id="experience">
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </select>
              <span
                class="pe-5"
                style="color: red"
                *ngIf="
                  (EmployeeStatus &&
                    EmployeeStatus.invalid &&
                    EmployeeStatus.touched) ||
                  (bool1 && EmployeeStatus && EmployeeStatus.invalid)
                "
              >
                Required</span
              >
            </p>
          </div>
  
          <div class="col-md-12">
            <p>
              <label class="noticePeriod experience"
                >Notice Period (If Any)</label
              >
              <input
                type="text"
                maxlength="2"
                formControlName="notice"
                placeholder="(None/Number of Days)"
                numbersOnly
              />
              <ng-container
                *ngIf="
                  notice && notice.invalid && notice.touched && notice.dirty;
                  else second || (bool1 && notice && notice.invalid)
                "
              >
                <span class="pe-5" style="color: red"> invalid </span>
              </ng-container>
              <ng-template #second>
                <ng-container
                  *ngIf="
                    (notice && notice.touched && notice.invalid) ||
                    (bool1 && notice && notice.invalid)
                  "
                >
                  <span class="pe-5" style="color: red"> Required</span>
                </ng-container>
              </ng-template>
              <ng-template #third></ng-template>
            </p>
          </div>
          <div class="col-md-7 resume-column">
            <p class="resume">
              <label class="experience">Upload Resume</label>
  
              <input
                type="file"
                hidden
                class="resume-uploads"
                multiple
                accept="*/*"
                #resumeFileUpload
                (change)="resumeGotSelected($event)"
              />
              <span
                ><button class="resume-btn" (click)="selectResume()">
                  Choose File
                </button>
                <input
                  type="text"
                  id="resume"
                  class="resumebtn"
                  formControlName="filename"
                  placeholder="No File Chosen"
                  [readonly]="true"
              /></span>
              <span class="pe-5" style="color: red" *ngIf="bool2 && bool1">
                Required
              </span>
            </p>
          </div>
          <div class="col-md-5 button-column">
            <re-captcha class="captcha-btn" formControlName="captcha"  (resolved)="verifyCaptcha($event)" [siteKey]="captchaSiteKey"></re-captcha>
        </div>
          <div class="col-md-12">
            <button class="submitButton" id="submit" (click)="sendEmail(id)" [disabled]="!applyForm.valid"
            [ngClass]="{
              'submitButton-enabled': applyForm.valid,
              'submitButton-disabled': !applyForm.valid
            }">
              Submit
            </button>
          </div>
        </div>
      </form>
      <div class="row mobile-gap">
        <div class="py-3">
          <a class="linkbutton" href="{{ jobDetails?.PostLink }}" target="_blank">
            View on LinkedIn
          </a>
        </div>
      </div>
    </div>
  </div>
</div>

